import { render } from 'preact'
import { App } from './app'
import { MobileBrowserNotice } from './components/MobileBrowserNotice'
import './index.css'

render(
  <>
    <App />
    <MobileBrowserNotice />
  </>,
  document.getElementById('app')!,
)
